import { memo, useMemo } from "react";

import SpacePath from "components/SpacePath";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { type RenderGroupRowCellProps } from ".";
import useIacManagementAnalytics from "../../useIacManagementAnalytics";
import useCellFilterAction from "../useCellFilterAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import IacManagementGroupCell from "../../components/Table/Row/Group/Cell";

const IacManagementTableGroupRowCellSpace = memo((props: RenderGroupRowCellProps) => {
  const { row } = props;

  const { analyticPage } = useIacManagementAnalytics();

  const isStackRow = row.__typename === "ManagedEntitiesGroupedByStacks";
  const spaceId = (isStackRow && row.stackSpaceID) || undefined;
  const spaceName = (isStackRow && row.stackSpaceName) || spaceId;

  const spaceFilterAction = useCellFilterAction(ResourcesSuggestions.Space, spaceId || "");
  const actions = useMemo(
    () => (spaceId ? [spaceFilterAction] : undefined),
    [spaceId, spaceFilterAction]
  );

  return (
    <IacManagementGroupCell {...props} actions={actions}>
      {spaceId ? (
        <SpacePath
          spaceId={spaceId}
          fallbackName={spaceName}
          analyticsPage={analyticPage}
          analyticsTitle="Space name link clicked"
          analyticsProps={{ driftsDetectedCount: row.drifted }}
        />
      ) : (
        <TableCellEmpty />
      )}
    </IacManagementGroupCell>
  );
});

IacManagementTableGroupRowCellSpace.displayName = "IacManagementTableGroupRowCellSpace";

export default IacManagementTableGroupRowCellSpace;
